import { useSelector } from 'react-redux';

export const useShowMedicines = () => {
  const { settings, isFetched } = useSelector((state) => state.setting);
  return isFetched && settings?.medicinAllowed === true;
};
